export enum UserProfileAbsenceDataGridField {
  ABSENT_TIME = 'absentTime',
  ACTIONS = 'actions',
}
